import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FunctionComponent, useState } from 'react';
import styles from './tree-view.component.module.scss';

export type TreeViewNodeConfig = {
  title: string,
  isToggled: boolean,
  uri?: string,
  children?: TreeViewNodeConfig[]
}

type TreeViewNodeProps = {
  node: TreeViewNodeConfig;
  indentLevel?: number;
  isRootNode?: boolean;
}

const TreeViewNode: FunctionComponent<TreeViewNodeProps> = ({ node, indentLevel, isRootNode }) => {
  const [isToggled, setIsToggled] = useState(node.isToggled);
  const indent = indentLevel || 0;

  const indentStyle = {
    marginLeft: `${indent * 1.5}rem`
  };

  const getHeader = () => {
    if (!node.children || node.children.length == 0) {
      return <a href={node?.uri}>{node.title}</a>;
    }

    const toggleStyle = {
      transform: `rotateZ(${isToggled ? '90deg' : '0'})`
    };

    return (
      <div className={styles.header}>
        <FontAwesomeIcon icon={faChevronRight} className={styles.icon} style={toggleStyle}/>
        <span className={styles.title}>{node.title}</span>
      </div>
    );
  };

  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setIsToggled(!isToggled);
  };

  return (
    <div className={`${styles.treeViewNode} ${isRootNode ? styles.root : styles.child}`} onClick={onClick}
         style={indentStyle}>
      {getHeader()}
      {isToggled && node.children?.map(child => (
        <TreeViewNode key={child.title} node={child} indentLevel={indent + 1}/>
      ))}
    </div>
  );
};

export default TreeViewNode;